export interface OldAddressMeterReadingState {
  movingDate: Date | null
}

export function GetInitialState(): OldAddressMeterReadingState {
  return {
    movingDate: null
  }
}
